import { render } from "./ZBCD.vue?vue&type=template&id=b395d60a&scoped=true"
import script from "./ZBCD.vue?vue&type=script&lang=js"
export * from "./ZBCD.vue?vue&type=script&lang=js"

import "./ZBCD.vue?vue&type=style&index=0&id=b395d60a&lang=css"
import "./ZBCD.vue?vue&type=style&index=1&id=b395d60a&scoped=true&lang=css"

import exportComponent from "D:\\wcb\\www\\wifigolf\\s_api\\public\\ClpgaApp121\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b395d60a"]])

export default __exports__